import { render, staticRenderFns } from "./Attachs.vue?vue&type=template&id=0a2799f8&scoped=true"
import script from "./Attachs.vue?vue&type=script&lang=js"
export * from "./Attachs.vue?vue&type=script&lang=js"
import style0 from "./Attachs.vue?vue&type=style&index=0&id=0a2799f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2799f8",
  null
  
)

export default component.exports